import { Component, Input, OnInit } from '@angular/core';
import { TransportShipmentModel } from '../shipment-group-list.component';

@Component({
  selector: 'app-shipment-group-shipment-list',
  templateUrl: './shipment-group-shipment-list.component.html',
  styleUrls: ['./shipment-group-shipment-list.component.scss']
})
export class ShipmentGroupShipmentListComponent implements OnInit {

  @Input()
  shipments: TransportShipmentModel[] = [];

  constructor() { }

  ngOnInit() {
  }

}
